module.exports = __webpack_public_path__ + "static/media/kath.3897c73b.jpg";